import '../common/app';

export default angular.module('edge.gateway.quoteandbind.pa.app', ['edge.gateway.quoteandbind.common.app']).value('pa.qnb.editableDriverDOB', true);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=pa!./common/js/src/edge/gateway/quoteandbind/pa/app.js
// module id = 478
// module chunks = 0